module.exports = __webpack_public_path__ + "static/media/18ECA12.cc242f41.jpg";